<template>
  <div class="toast">
    <span v-html="msg"></span>
  </div>
</template>
<script>
export default {
  props: ["msg"],
};
</script>
<style scoped>
.toast {
  width: fit-content;
  padding: 14px 30px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  background: rgba(0, 0, 0, 0.76);
  border-radius: 10px;
  color: var(--white);
  position: fixed;
}
</style>
<style src="@/assets/css/newGlobal.css" scoped></style>
